import axios from 'axios'

const PROFILE = process.env.VUE_APP_PROFILE

class ProfileCalls {

  get(id) {
    return axios.get(PROFILE + "id/" + id)
    .then(response => response.data.profile);
  }

  getAll() {
    return axios.get(PROFILE + "all/")
    .then(response => response.data.profiles);
  }

  search(query, options) {
    return axios.post(PROFILE + "all/", { query, options })
    .then(response => response.data.profiles);
  }

  edit(newProfile, id) {
    return axios.put(PROFILE + "id/" + id, { newProfile })
    .then(response => response.data.profile);
  }

  getChaptersData(ids) {
    return axios.post(PROFILE + "ids/", { ids, attributes: ['id', 'name', 'fullName', 'profileImg'] })
    .then(response => response.data.profiles);
  }

  getChapterData(id) {
    return this.getChaptersData(id)
    .then(profiles => profiles[0]);
  }

  addChapter(author, chapterId) {
    return axios.post(PROFILE + `chapters/id/${author}/`, { chapterId: chapterId })
    .then(response => response.data.profileId);
  }

}

const profileCalls = new ProfileCalls();
export default profileCalls;
